
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/opnunartimar",
      function () {
        return require("private-next-pages/um/fyrirtaekid/opnunartimar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/opnunartimar"])
      });
    }
  